import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const CartContext = createContext();
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const generateCartId = () => 'cart_' + Math.random().toString(36).substr(2, 9);

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState({ items: [], total: 0 });
    const [loading, setLoading] = useState(false);
    const [cartId] = useState(() => {
        let id = localStorage.getItem('ysc_cart_id');
        if (!id) { id = generateCartId(); localStorage.setItem('ysc_cart_id', id); }
        return id;
    });

    const fetchCart = useCallback(async () => {
        try { const r = await axios.get(`${API}/cart/${cartId}`); setCart(r.data); }
        catch (e) { console.error(e); }
    }, [cartId]);

    useEffect(() => { fetchCart(); }, [fetchCart]);

    const addToCart = async (product, quantity=1, size=null) => {
        setLoading(true);
        try { const r = await axios.post(`${API}/cart/${cartId}/add`, {product_id:product.id,name:product.name,price:product.price,quantity,size,image_url:product.image_url}); setCart(r.data); }
        catch(e){console.error(e);} finally{setLoading(false);}
    };
    const removeFromCart = async (productId, size=null) => {
        setLoading(true);
        try { await axios.post(`${API}/cart/${cartId}/remove?product_id=${productId}${size?`&size=${size}`:''}`); await fetchCart(); }
        catch(e){console.error(e);} finally{setLoading(false);}
    };
    const updateQuantity = async (productId, quantity, size=null) => {
        setLoading(true);
        try { const r = await axios.post(`${API}/cart/${cartId}/update-quantity?product_id=${productId}&quantity=${quantity}${size?`&size=${size}`:''}`); setCart(r.data); }
        catch(e){console.error(e);} finally{setLoading(false);}
    };
    const clearCart = async () => {
        setLoading(true);
        try { await axios.delete(`${API}/cart/${cartId}/clear`); setCart({items:[],total:0}); }
        catch(e){console.error(e);} finally{setLoading(false);}
    };

    const itemCount = cart.items.reduce((sum,item) => sum+item.quantity, 0);
    return (
        <CartContext.Provider value={{cart,loading,addToCart,removeFromCart,updateQuantity,clearCart,itemCount,fetchCart}}>
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => {
    const context = useContext(CartContext);
    if (!context) throw new Error('useCart must be used within CartProvider');
    return context;
};
